import React from "react";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";

import DialogTitle from "@mui/material/DialogTitle";
import { Button, FormControlLabel, MenuItem, Select } from "@mui/material";
import { Box, Typography } from "@mui/material";

import { Formik } from "formik";
import TextField from "@mui/material/TextField";
import Switch from "@mui/material/Switch";

const RedditSettingsPopupForm = (props) => {
  const label = { inputProps: { "aria-label": "Switch demo" } };

  const { open, close, task, updateTaskParams } = props;

  const {
    focused,
    threshold,
    monitoring,
    monitoring_interval,
    submission_limit,
    subreddit
  } = task;

  console.log("MONIT ", monitoring_interval);

  return (
    <Formik
      initialValues={{
        submission_limit: submission_limit,
        focused: focused,
        threshold: threshold,
        monitoring_interval: monitoring_interval,
        monitoring: monitoring,
        subreddit:subreddit
      }}
      onSubmit={(values) => {
        updateTaskParams({ ...values });
      }}
    >
      {({ handleChange, handleBlur, handleSubmit, resetForm, values }) => (
        <Dialog open={open}>
          <DialogTitle>
            <Typography> {subreddit} </Typography>
          </DialogTitle>
          <DialogContent>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                minWidth: 300,
                minHeight: 300,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flex: 1,
                  flexDirection: "column",
                  justifyContent: "space-evenly",
                }}
              >
               
                <FormControlLabel
                  control={
                    <Switch
                      onChange={handleChange("monitoring")}
                      value={values.monitoring}
                      checked={values.monitoring}
                    />
                  }
                  label={"Monitoring"}
                />

                <FormControlLabel
                  control={
                    <Switch
                      {...label}
                      onChange={handleChange("focused")}
                      value={values.focused}
                      checked={values.focused}
                    />
                  }
                  label={"Focused"}
                />
                <Box sx={{height:40}}>
                   {/* This box exists for formatting reasons. Do not delete */}
                </Box>
               
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flex: 1,
                  flexDirection: "column",
                  justifyContent: "space-evenly",
                  alignItems: "flex-end",
                }}
              >

                <TextField
                  sx={{ maxWidth: 100, minWidth: 100 }}
                  onChange={handleChange("monitoring_interval")}
                  value={values.monitoring_interval}
                  variant="outlined"
                  type="number"
                  label="Interval (days)"
                  size="small"
                  InputProps={{ inputProps: { min: 0 } }}
                />

                <TextField
                  sx={{ maxWidth: 100, minWidth: 100 }}
                  onChange={handleChange("threshold")}
                  value={values.threshold}
                  variant="outlined"
                  type="number"
                  label="Threshold"
                  size="small"
                  InputProps={{
                    inputProps: { min: 0, max: 1, step: 0.1 },
                  }}
                />

<TextField
                  sx={{ maxWidth: 100, minWidth: 100 }}
                  onChange={handleChange("submission_limit")}
                  value={values.submission_limit}
                  variant="outlined"
                  type="number"
                  label="Submission limit"
                  size="small"
                  InputProps={{
                    inputProps: { min: 0, step: 1 },
                  }}
                />

              </Box>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              variant={"contained"}
              onClick={() => {
                handleSubmit();
                close();
              }}
            >
              OK
            </Button>
            <Button
              variant="outlined"
              onClick={() => {
                resetForm();
                close();
              }}
            >
              Cancel
            </Button>
            {/* <Button onClick={handleClose}>Subscribe</Button> */}
          </DialogActions>
        </Dialog>
      )}
    </Formik>
  );
};

export default RedditSettingsPopupForm;
